import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'
import { sessionService } from '../../store/session'
import { YupUtils } from '../../utils/yup.utils'
import ModalForm, { ModalFormProps } from '../common/ModalForm.common'
import { ItemType, FormItem } from '../../models/props.models'

interface ModalCheckPhoneNumberProps
  extends Omit<
    ModalFormProps,
    'title' | 'description' | 'value' | 'setValue' | 'items' | 'submitLabel'
  > {}

const ModalCheckPhoneNumber: React.FC<ModalCheckPhoneNumberProps> = (props) => {
  const { t } = useTranslation()
  const [value, setValue] = useState<{phoneNumber: string}>({ phoneNumber: '' })
  const phoneNumber = useMemo(
    () =>
      sessionService.getCountryParam('phoneNumber') as
        | { format: string; validation: string }
        | undefined,
    [],
  )

  const items: FormItem[] = useMemo(
    () => [
      {
        key: 'phoneNumber',
        type: ItemType.text,
        required: true,
        rules: [
          phoneNumber
            ? { rule: YupUtils.FieldValidationType.regexp, params: phoneNumber.validation }
            : () => '',
        ],
        props: {
          pattern: phoneNumber?.format,
          label: t('users:attributes.phoneNumber'),
          placeholder: t('users:attributes.phoneNumberFormat'),
          autocomplete: 'tel',
        },
      },
    ],
    [t, phoneNumber],
  )

  return (
    <ModalForm
      {...props}
      value={value}
      setValue={setValue}
      items={items}
      title={t('orders:components.modalCheckPhoneNumber.title')}
      description={t('orders:components.modalCheckPhoneNumber.description')}
      submitLabel={t('global:actions.add')}
    />
  )
}

export default ModalCheckPhoneNumber
